// extracted by mini-css-extract-plugin
export default {"GroupsTableRowMenu":"GroupsTableRowMenu_GroupsTableRowMenu__ooXJX"};